import { render, staticRenderFns } from "./TabsView.vue?vue&type=template&id=79ca510a&scoped=true&lang=pug"
import script from "./TabsView.vue?vue&type=script&lang=ts"
export * from "./TabsView.vue?vue&type=script&lang=ts"
import style0 from "./TabsView.vue?vue&type=style&index=0&id=79ca510a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ca510a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79ca510a')) {
      api.createRecord('79ca510a', component.options)
    } else {
      api.reload('79ca510a', component.options)
    }
    module.hot.accept("./TabsView.vue?vue&type=template&id=79ca510a&scoped=true&lang=pug", function () {
      api.rerender('79ca510a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Tabs/TabsView.vue"
export default component.exports